import Immutable from 'seamless-immutable'
import * as actions from '../actions/loading'
import {getLoadingKey} from '../../lib/util/loading'

const initialState = Immutable({
	modalSpinnerIsShowing: false
})

export default function (state = initialState, action){

	switch(action.type){
		case actions.IS_LOADING:
			return state.updateIn(getLoadingKey(action.name), (obj) => {
				const status = {
					isLoading: true,
					timestamp: Date.now(),
					exception: false
				}

				return obj ? obj.merge(status, {deep: true}) : status
			})

		case actions.RESET_LOADING:
		case actions.FINISHED_LOADING:
			const resetState = (action, state) => state.updateIn(getLoadingKey(action.name), (obj) => {
				const status = {
					isLoading: false,
					totalTime: Date.now() - (obj || {timestamp: Date.now()}).timestamp,
					exception: action.error,
					exceptionCode: action.errorCode,
					exceptionType: action.exceptionType
				}

				return obj ? obj.merge(status, {deep: true}) : status
			})
			const hasOwnIsLoadingProperty = (obj, prop) => obj[prop] && obj[prop].hasOwnProperty('isLoading')

			if(action.resetType == actions.RESET_TYPE_INCLUDE_SUB_KEYS && !Array.isArray(action.name)){
				let loadingState = state[action.name] && state[action.name].hasOwnProperty('isLoading') ? resetState(action, state) : state
				Object.keys(state[action.name] || {}).forEach(x => {
					if(hasOwnIsLoadingProperty(state[action.name], x)){
						loadingState = resetState({name: [action.name, x]}, loadingState)
					}
				})
				return loadingState
			}else{
				return resetState(action, state)
			}
	}

	return state
}



// WEBPACK FOOTER //
// ./node_modules/mb-app-common/store/reducers/loading.js